module.exports = __webpack_public_path__ + "img/img1.6df582e1.jpg";